<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="500">
      <template v-slot:activator="{ on, attrs }">
        <span v-if="title != null">
          <v-btn
              color="warning"
              class="ml-3"
              :loading="loading"
              :disabled="disabled"
              v-on="on"
          >
            {{ title }}
          </v-btn>
        </span>
        <span v-else>
          <v-icon color="primary" small v-bind="attrs" v-on="on" :loading="loading" :disabled="disabled">
            mdi-delete-outline
          </v-icon>
        </span>
      </template>
      <v-card>
        <v-card-title class="text-h5">
          Are you sure you want to delete this item?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="onClose">Cancel</v-btn>
          <v-btn color="green darken-1" text @click="onDelete">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
export default {
  name: 'BaseDeleteDialog',
  inheritAttrs: false,
  props:
    {
      'loading': {type: [Boolean], default: false},
      'item': {type: [Object], default: null},
      'onDeleteAction': {type: [Function], default: null},
      'disabled': {type: [Boolean], default: true},
      'title': {type: [String], default: null},
    },

  methods: {
    onClose() {
      this.dialog = false
    },
    onDelete() {
      this.dialog = false
      this.onDeleteAction(this.item)
    },
  },

  mounted() {
  },

  data() {
    return {
      dialog: false,
    }
  },
}
</script>


<style scoped lang="scss">
</style>